<template>
  <div class="container" v-if="!loading">
    <table>
      <tr>
        <td class="title green">
          {{ document.amount }} {{ document.locale_currency }}
        </td>
      </tr>
      <tr>
        <td class="title blue">
          {{ document_type }} de {{ document.organization_name }}
        </td>
      </tr>
      <tr>
        <td style="padding-top: 4px">
          <span class="pd5 bgGrey blue radius5">
            À régler avant le {{ transformDate(document.payment_deadline_at) }}
          </span>
        </td>
      </tr>
    </table>

    <div class="containerButton mt30 mb40">
      <div class="containerButtonInfo" @click="showModalPaiement">
        <div class="bgGreen w175 h30 radius5 txtButton">
          <i class="fa fa-lock mr10 white" aria-hidden="true"></i>
          Régler {{ document.amount }} {{ document.locale_currency }}
        </div>

        <span class="darkBlue">Payement par CB sécursé</span>
      </div>

      <span class="pd20H pd10Top darkBlue fw600"> OU </span>

      <div class="containerButtonInfo" id="importButton">
        <div class="bgBlue w175 h30 radius5 txtButton">
          Importer en comptabilité
        </div>

        <span class="darkBlue">Importation et gestion automatique</span>
      </div>

      <div class="dropDownBanner">
        <div class="card bgWhite">
          <div class="cardHeader">
            <h1 class="cardTitle darkBlue">Fichier .FEC</h1>
          </div>

          <div>
            <span class="darkBlue">
              Télécharger le fichier d’ecriture comptable pour importer dans
              votre logiciel comptable.
            </span>
          </div>

          <div>
            <div
              class="cardButton button bgBlue txtButton"
              @click="downloadFecDocument"
            >
              <span class="white" style="font-weight: 600; font-size: 13px">
                Télécharger (.FEC)
              </span>
            </div>
          </div>
        </div>

        <div class="card bgGreen">
          <div class="cardHeader">
            <img class="cardLogo" src="../assets/logo-white.svg" alt="" />
            <span class="white pd3Left"> connect </span>
          </div>

          <div>
            <span class="white">
              Échangez automatiquement des factures avec vos clients et
              fournisseurs sans saisie manuelle.
            </span>
          </div>

          <div>
            <div
              class="cardButton button bgWhite txtButton"
              @click="showModalImport"
            >
              <span class="green" style="font-weight: 600; font-size: 13px">
                Découvrir Sinao
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="containerDocument">
      <div class="containerDownload" @click="downloadDocument">
        <i class="fas fa-save"></i>
        <span class="darkBlue pf10">Télécharger la facture (PDF)</span>
      </div>

      <img :src="'data:image/png;base64,' + document.preview" />
    </div>

    <ModalPaiement
      v-show="isModalPaiementVisible"
      @close="closeModalPaiement"
      :bank_details="bank_details"
      :document="document"
      :client_id="client_id"
      :token="token"
    />

    <ModalImportSinao v-show="isModalImportVisible" @close="closeModalImport" />
  </div>
</template>

<script>
import ModalPaiement from "../components/Modals/ModalPaiement.vue";
import ModalImportSinao from "../components/Modals/ModalImportSinao.vue";

import Vue from "vue";
import { query } from "sinao-corejs";
import jsPDF from "jspdf";

export default {
  name: "Export_document",
  props: {},
  data() {
    return {
      loading: true,
      token: "",
      bank_details: {},
      document: {},
      client_id: "",
      document_type: "",
      isModalPaiementVisible: false,
      isModalImportVisible: false,
    };
  },
  components: {
    ModalPaiement,
    ModalImportSinao,
  },
  filters: {
    decodeBase64(value) {
      return atob(value);
    },
  },
  // created() {
  // },

  async created() {
    this.loading = true;

    let urlParams = new URLSearchParams(window.location.search);
    this.token = urlParams.get("token");
    if (this.token == null) {
      // redirect to sinao.fr
    }

    await query({
      operationId: "app.documents.sales.exportinvoice.token_validation",
      params: {
        token: this.token,
      },
    }).then((response) => {
      this.bank_details = response.bank_details;
      this.document = response.document;
      this.client_id = response.client_id;
      this.document_type = response.document_type;

      this.loading = false;
    });
  },
  methods: {
    transformDate(stringDate) {
      let newDate = new Date(stringDate);

      let day =
        newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();

      let mounth =
        newDate.getMonth() + 1 < 10
          ? "0" + (newDate.getMonth() + 1)
          : newDate.getMonth() + 1;

      return day + "/" + mounth + "/" + newDate.getFullYear();
    },
    showModalPaiement() {
      if (
        this.document.amount > 0 &&
        (this.bank_details.name != null || this.client_id != "")
      ) {
        this.isModalPaiementVisible = true;
      } else {
        if (this.document.amount > 0) {
          Vue.$toast.open({
            message: "Impossible de rélger une facture de 0€",
            type: "error",
          });
        } else {
          Vue.$toast.open({
            message:
              "Impossible de rélger la facture, votre fournisseur n'a pas renseigné ses coordonnées de paiement",
            type: "error",
          });
        }
      }
    },
    closeModalPaiement() {
      this.isModalPaiementVisible = false;
    },
    showModalImport() {
      this.isModalImportVisible = true;
    },
    closeModalImport() {
      this.isModalImportVisible = false;
    },
    downloadDocument() {
      const pdf = new jsPDF("p", "mm", "a4");

      const img = new Image();
      img.src = "data:image/png;base64," + this.document.preview;

      // Calculate the dimensions and position to fit the image on the page
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imageWidth = pageWidth - 20;
      const imageHeight = (imageWidth * img.height) / img.width;
      const x = 10;
      const y = (pageHeight - imageHeight) / 2;

      pdf.addImage(img, "PNG", x, y, imageWidth, imageHeight);
      pdf.save(this.document.number + ".pdf");
    },
    async downloadFecDocument() {
      await query({
        operationId: "app.documents.sales.exportinvoice.download_invoice_fec",
        params: {
          token: this.token,
        },
      }).then((response) => {
        console.log(response);
      });
    },
  },
};
</script>

<style>
.container {
  width: 65%; /* 50% */
  margin: auto;
}

.title {
  font-family: "Times";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 109.02%;
}

.txtButton {
  font-size: 13px;
  font-weight: 400; /* SEMI-BOLD */
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.link {
  text-decoration: none;
}

.link:link,
.link:visited {
  color: #369e3b;
}

.containerButton {
  display: flex;
  justify-content: left;
  width: fit-content;

  position: relative;
}

.containerButtonInfo {
  text-align: center;
  cursor: pointer;
}

.containerDownload {
  display: flex;
  align-content: center;
  justify-content: end;
  margin-bottom: 10px;
  cursor: pointer;
}

.containerDocument img {
  width: 100%;
  margin: auto;
}

.dropDownBanner {
  position: absolute;
  top: 35px; /* 50px */
  right: calc(-280px + 176px / 2);
  display: none;
  border-radius: 5px;
}

#importButton:hover + .dropDownBanner,
.dropDownBanner:hover {
  display: flex !important;
  /* border: 1px solid #ebeff2; */
  box-shadow: 0px 2px 2px rgba(50, 45, 40, 0.1),
    0px 6px 15px rgba(54, 47, 40, 0.25);
}

.card {
  padding: 25px 40px;
  width: calc(280px - 80px);
}

.card:first-child {
  border-radius: 5px 0 0 5px;
}
.card:last-child {
  border-radius: 0 5px 5px 0;
}

.cardHeader {
  display: flex;
  justify-content: left;
  align-items: end;
  margin-bottom: 10px;
}

.cardTitle {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  font-style: normal;
  letter-spacing: 0.01em;
  margin: 0px;
}

.cardLogo {
  width: 73px;
  height: 24px;
}

.cardButton {
  margin-top: 13px;
  width: calc(100% - 30px);
  height: 32px;
  border-radius: 5px;
}

/* -- Mobile --*/
@media screen and (max-width: 630px) {
  .container {
    width: 95%;
  }

  .containerButton {
    margin: auto;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 430px) {
  .title {
    font-size: 25px;
  }

  .containerButton {
    display: grid;
  }

  .containerButton:nth-child(2) {
    margin-bottom: 0px !important;
  }

  #ou {
    display: none;
  }

  .containerButtonInfo {
    margin-bottom: 20px;
  }

  .mb40 {
    margin-bottom: 20px !important;
  }
}
</style>
